import { render } from "./LanguageSelectorBlock.vue?vue&type=template&id=c97b59ca&scoped=true"
import script from "./LanguageSelectorBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSelectorBlock.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSelectorBlock.vue?vue&type=style&index=0&id=c97b59ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97b59ca"],['__file',"resources/js/components/LanguageSelectorBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c97b59ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c97b59ca', __exports__)) {
    api.reload('c97b59ca', __exports__)
  }
  
  module.hot.accept("./LanguageSelectorBlock.vue?vue&type=template&id=c97b59ca&scoped=true", () => {
    api.rerender('c97b59ca', render)
  })

}


export default __exports__